// extracted by mini-css-extract-plugin
export default {"wrap":"MainNews_wrap__caCxP","head":"MainNews_head__VVbk8","list":"MainNews_list__6OAII","item":"MainNews_item__Rs9w9","date":"MainNews_date__bg-wn","name":"MainNews_name__RnOEd"};